module.exports = __webpack_public_path__ + "static/media/IMG_3926.1ce686e8.JPG";